// @ts-nocheck
require('jquery-validation/dist/jquery.validate');
require('jquery-validation/dist/additional-methods');

module.exports = {};
